import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { PageHero } from "@/components/layout/PageHero";
import { CtaBand } from "@/components/layout/CtaBand";
import { Section } from "@/components/layout/Section";
import { Reveal } from "@/components/common/Reveal";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQ } from "@/content/homeContent";

export default function Faq() {
  return (
    <SiteLayout>
      <PageHero
        testId="faq-page"
        micro={FAQ.microLabel}
        title="Le risposte più utili."
        description="Le domande più frequenti su file, materiali, preventivo, tempi e riservatezza. Se non trovi la risposta, scrivici."
      />

      <Section id="faq-page-section" tone="light">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible className="w-full">
              {FAQ.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-page-item-${i}`}
                  className="border-strato-gray-100"
                >
                  <AccordionTrigger className="text-left font-display text-lg font-medium text-strato-graphite hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-[1.65] text-muted-foreground">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </Section>

      <CtaBand secondaryTo="/contatti" secondaryLabel="Contattaci" />
    </SiteLayout>
  );
}
